import React from 'react';

// Shared "roof" banner — same household photo (or default plate) sits atop both
// the Chores and Analytics tabs, just at different heights. When there's no
// photo, the plate itself (texture + name + member-color stripe) is the design,
// not an empty gap waiting for one.
const HouseholdBanner = ({ household, height, eyebrow, heading, rightSlot, memberColors = [] }) => {
  const hasPhoto = !!household?.bannerUrl;

  return (
    <div className="mb-6 relative" style={{ height }}>
      {/* Texture backdrop — shows through while a photo loads, or stands alone as the default plate */}
      <div
        className="absolute inset-0"
        style={{
          background: 'repeating-linear-gradient(122deg, rgba(245,242,236,.075) 0 5px, transparent 5px 12px), radial-gradient(120% 90% at 12% 0%, rgba(255,255,255,.05), transparent 60%)',
        }}
      />
      {hasPhoto && (
        <img
          src={household.bannerUrl}
          alt="Household banner"
          className="absolute inset-0 w-full h-full object-cover"
          style={{
            objectPosition: household.bannerPosition || '50% 50%',
            transform: `scale(${household.bannerZoom || 1})`,
            transformOrigin: household.bannerPosition || '50% 50%',
          }}
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      )}
      <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-ink-overlay/90 via-ink-overlay/20 to-transparent" />
      <div className="absolute inset-0 flex flex-col justify-end p-5">
        <div className="flex items-end justify-between gap-3">
          <div className="min-w-0">
            <p className="text-[10px] font-mono font-medium tracking-widest uppercase text-ink-banner/55 truncate">{eyebrow}</p>
            <h3 className="text-ink-banner font-serif text-xl mt-1 truncate">{heading}</h3>
          </div>
          {rightSlot}
        </div>
        {!hasPhoto && memberColors.length > 0 && (
          <div className="flex gap-1 mt-3">
            {memberColors.map((c, i) => (
              <div key={i} className="h-1 rounded-full" style={{ width: 28 - i * 4, backgroundColor: c }} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default HouseholdBanner;
